import mongoose from 'mongoose'

const demoSchema = new mongoose.Schema({})

export default demoSchema
